import { type ITokenProvider, type TokenProviderResponse } from '@pusher/push-notifications-web'
import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type { UserTokenResponse } from '~/plugins/push-notifications/client/http/types/UserTokenResponse'
import type { TPushSubscriptionKeys } from '~/plugins/push-notifications/client/types/TPushSubscriptionKeys'
import type { TPushSubscriptionPayload } from '~/plugins/push-notifications/client/types/TPushSubscriptionPayload'

class UserNotificationAPI extends Http implements ITokenProvider {
  fetchToken = (userId: string): Promise<TokenProviderResponse> => {
    return this.callAuthWithPropertyAPI<null, UserTokenResponse>(HttpMethod.GET, {
      path: APIPaths.USER_NOTIFICATION_PUSHER_BEAMS_TOKEN,
      params: {
        userId: userId,
      },
    })
  }

  subscribe = (subscription: TPushSubscriptionPayload): Promise<void> => {
    return this.callAuthWithPropertyAPI<TPushSubscriptionPayload, void>(
      HttpMethod.POST,
      {
        path: APIPaths.USER_NOTIFICATION_SUBSCRIBE,
      },
      subscription,
    )
  }

  unsubscribe = (keys: TPushSubscriptionKeys): Promise<void> => {
    return this.callAuthWithPropertyAPI<TPushSubscriptionKeys, void>(
      HttpMethod.POST,
      {
        path: APIPaths.USER_NOTIFICATION_UNSUBSCRIBE,
      },
      keys,
    )
  }

  activate = (keys: TPushSubscriptionKeys): Promise<void> => {
    return this.callAuthWithPropertyAPI<TPushSubscriptionKeys, void>(
      HttpMethod.POST,
      {
        path: APIPaths.USER_NOTIFICATION_ACTIVATE,
      },
      keys,
    )
  }

  deactivate = (keys: TPushSubscriptionKeys): Promise<void> => {
    return this.callAuthWithPropertyAPI<TPushSubscriptionKeys, void>(
      HttpMethod.POST,
      {
        path: APIPaths.USER_NOTIFICATION_DEACTIVATE,
      },
      keys,
    )
  }
}

export const useUserNotificationsAPI = (): UserNotificationAPI => {
  return new UserNotificationAPI()
}
